module.exports = __webpack_public_path__ + "static/media/20ECE27.5bee6840.jpg";